/**
 * The navigation: Plan, Milk sales, To do and Milk Flow beside it.
 *
 * Decision B09 (Ronald, 27 September 2026): the top tab is named "Plan", and
 * the week and the day sit under it, as the switch on those pages
 * (`PlanSwitch`). Since 16 October 2026 Plan opens the collections as they are
 * driven now (/plan, Ronald: "only show actual plans that are currently in
 * operation"); the optimiser's runs under /runs are out of the navigation and
 * still mark Plan as current when reached by a link. Milk sales and To do (16
 * October 2026) replace the one tickets page named after a buyer: what is sold, with the
 * buyer as a choice, and what waits for a person.
 * Milk trading (DM-3, 18 October 2026) holds the contracts and offers with their prices; Milk sales keeps the
 * litres for the transport office.
 * Milk Flow (14 October 2026, spec MF-1) is milk in, out and in the silos, an entry of its own too.
 *
 * `AppShell` renders the `<nav>` landmark around whatever it is handed, so
 * this supplies the list inside it and no second landmark.
 */
import { Link, useLocation } from "react-router-dom";

export function Nav() {
  const { pathname } = useLocation();
  const current = pathname === "/" || pathname === "/plan" || pathname === "/runs" || pathname.startsWith("/runs/");
  const closures = pathname === "/closures";
  const sales = pathname === "/sales";
  const toDo = pathname === "/to-do";
  const trading = pathname === "/trading";
  const milkFlow = pathname === "/milk-flow" || pathname.startsWith("/milk-flow/");
  return (
    <ul className="nav" role="list">
      {/* Road closures are under Plan: a list inside Plan's entry, so a
          screen reader hears them as part of it, laid out beside it. */}
      <li className="nav-group">
        <Link
          aria-current={current ? "page" : undefined}
          className={current ? "nav-item is-current" : "nav-item"}
          to="/plan"
        >
          Plan
        </Link>
        <ul className="nav" role="list">
          <li>
            <Link
              aria-current={closures ? "page" : undefined}
              className={closures ? "nav-item is-current" : "nav-item"}
              to="/closures"
            >
              Road closures
            </Link>
          </li>
        </ul>
      </li>
      <li>
        <Link
          aria-current={sales ? "page" : undefined}
          className={sales ? "nav-item is-current" : "nav-item"}
          to="/sales"
        >
          Milk sales
        </Link>
      </li>
      <li>
        <Link
          aria-current={trading ? "page" : undefined}
          className={trading ? "nav-item is-current" : "nav-item"}
          to="/trading"
        >
          Milk trading
        </Link>
      </li>
      <li>
        <Link
          aria-current={toDo ? "page" : undefined}
          className={toDo ? "nav-item is-current" : "nav-item"}
          to="/to-do"
        >
          To do
        </Link>
      </li>
      <li>
        <Link
          aria-current={milkFlow ? "page" : undefined}
          className={milkFlow ? "nav-item is-current" : "nav-item"}
          to="/milk-flow"
        >
          Milk Flow
        </Link>
      </li>
    </ul>
  );
}
